/** Convert response diagnostics to bounded text without rendering payload objects. */
export function errorMessage(value: unknown, fallback: string): string {
  const messages: string[] = [];
  const seen = new Set<object>();
  const ignored = new Set([
    "input",
    "ctx",
    "url",
    "raw",
    "raw_request",
    "raw_response",
  ]);
  const visit = (item: unknown, path: string[], depth: number) => {
    if (messages.length >= 12 || depth > 8) return;
    if (typeof item === "string") {
      if (item.trim())
        messages.push(
          `${path.length ? path.join(".") + ": " : ""}${item.slice(0, 1000)}`,
        );
      return;
    }
    if (!item || typeof item !== "object" || seen.has(item)) return;
    seen.add(item);
    if (Array.isArray(item)) {
      item.forEach((entry) => visit(entry, path, depth + 1));
      return;
    }
    const record = item as Record<string, unknown>;
    const diagnosticKeys = ["detail", "msg", "error", "message"].filter((key) =>
      Object.hasOwn(record, key),
    );
    for (const key of diagnosticKeys.length
      ? diagnosticKeys
      : Object.keys(record)) {
      if (ignored.has(key)) continue;
      visit(
        record[key],
        diagnosticKeys.length ? path : [...path, key],
        depth + 1,
      );
    }
  };
  visit(value, [], 0);
  return messages.join("; ").slice(0, 4000) || fallback;
}
